import { onMounted, ref } from 'vue';

import { isStyleSupport } from '@components/utils';

const supportSticky = ref(false);
export const useProvideSticky = () => {
  onMounted(() => {
    supportSticky.value = supportSticky.value || isStyleSupport('position', 'sticky');
  });
};

export const useInjectSticky = () => {
  return supportSticky;
};
